<template>
    <a class="navbar-toggler" :href="blok.page.cached_url | formatSbInternalLink" v-editable="blok" :target="target">
        <span class="toggler-icon">
            <font-awesome-icon icon="shopping-cart" size="lg"/>
            <b-badge pill variant="primary">{{ basket ? calculateLineItemsTotal(basket.lineItems) : 0 }}</b-badge>
        </span>
    </a>
</template>
<script>
import { mapActions, mapState } from "vuex";

export default {
    name: 'navigation-mobile-button-shopify',
    props: {
        target: {
            type: String,
            required: true
        },
        blok: {
            type: Object,
            required: true
        }
    },
    computed: {
        ...mapState({
            basket: state => state.shopify.checkout
        }),
        classes: function() {
            return [this.$props.blok.classes].join(" ");
        }
    },
    methods: {
      calculateLineItemsTotal: function(items) {
          return items.reduce( (a,v) => {
              return a + v.quantity;
          }, 0);
      }
    }
}
</script>
